<div class="frame">
  <app-charts></app-charts>
  <div class="footer-area"></div>
</div>
